import {
  Box,
  FormControl,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGlobalState } from "../../contexts/GlobalContext";
import {
  getEventMicroCMS,
  getEventSessionEntries,
  getSurveyId,
  getSurveyDetail,
  fetchUserInfoProxy,
  registerSession,
} from "../../utils/helpers/api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Regex, Routes } from "../../utils/constants";
import BasicInfo from "../Mypage/UserSetting/BasicInfo";
import BasicInterests from "../Mypage/UserSetting/BasicInterests";
import WorkPlace from "../Mypage/UserSetting/WorkPlace";
import HomePlace from "../Mypage/UserSetting/HomePlace";
import Input from "../../components/Commons/Input";
import { appConfig } from "../../utils/configs";
import { mappingUser } from "../../utils/constants/constant";
import { AxiosResponse } from "axios";
import { logger } from "../../utils/helpers/logger";
import { useNotificationTimestamp } from "../../hooks/features/notification/useNotificationTimestamp";

interface IStateLocation {
  dataEdit: IUserMetaDataApi;
  answerDataEdit: {
    ip_address?: string;
    pages?: IAnswerPage[];
  };
  agreeTerms?: boolean;
  agreements?: boolean;
  questionData: ISurveyDetail;
}
interface Field {
  field: string;
  label: string;
}
const SurveyAnswer: React.FC = () => {
  const { t } = useTranslation();
  const { globalState, setStateValue } = useGlobalState();
  const location = useLocation();
  const { dataEdit, answerDataEdit, agreeTerms, agreements, questionData } =
    (location.state as IStateLocation) ?? {};
  const { checkNewsletterFromMailmagId } = useNotificationTimestamp();
  const [state, setState] = useState<ISuveyAnswerState>({
    userMetaData: {},
    userMetaDataDetail: {},
    surveyData: {},
    answerData: {},
    subContactValue: {},
    errorMess: undefined,
    errorMessages: {},
    isAgreeTerms: false,
    isAgreements: false,
    dataMicroCMS: {},
    ondemand: false,
  });
  const navigate = useNavigate();
  const {
    userMetaData,
    answerData,
    subContactValue,
    errorMess,
    errorMessages,
    surveyData,
    isAgreeTerms,
    isAgreements,
    dataMicroCMS,
    userMetaDataDetail,
    ondemand,
  } = state;
  const [survey_id, set_survey_id] = useState<string | null>(null);
  const [user_hash, set_user_hash] = useState<string | null>(null);
  const [user_id, set_user_id] = useState<string | null>(null);
  const [display_mode, set_display_mode] = useState<number>(0);
  const [content, set_content] = useState({
    noti: "登録完了",
    mess: "お申込みありがとうございます。登録が完了しました。",
    hint: "お申込み登録完了のお知らせメールの詳細をご覧ください。",
  });
  const { survey_web_url_id } = useParams();
  const urlParams = new URLSearchParams(window.location.search);
  const event_id = urlParams.get("event_id");
  const event = urlParams.get("event");
  
  const selectedComponents = (mappingUser);

  const BasicInfoFields = [
    { field: "profile.fullName.firstName", label: "first_name" },
    { field: "profile.fullName.lastName", label: "last_name" },
    { field: "profile.fullNameKana.firstName", label: "first_name_kana" },
    { field: "profile.fullNameKana.lastName", label: "last_name_kana" },
    { field: "profile.birth.year", label: "year" },
    { field: "profile.birth.month", label: "month" },
    { field: "profile.birth.day", label: "day" },
    { field: "profile.occupationCode", label: "occupationCode" },
    { field: "profile.contactType", label: "contactType" },
  ];

  const PositionInfoFields = [
    { field: "workPlaceInfo.positionCode", label: "positionCode" },
    { field: "workPlaceInfo.affiliationCodes", label: "affiliationCodes" },
  ];


  const BasicInterestsFields =
    userMetaData?.transition_source === "kankyobusiness"
      ? [
        { field: "interest.environmentBusinessCodes", label: "environmentBusinessCodes" }
        ] 
      : [{ field: "interest.jobCodes", label: "jobCodes" }];

  const WorkPlaceFields = [
    { field: "workPlaceInfo.companyName", label: "companyName" },
    { field: "workPlaceInfo.phoneNumber", label: "phone03" },
    { field: "workPlaceInfo.city", label: "city" },
    { field: "workPlaceInfo.line", label: "line" },
    { field: "workPlaceInfo.postalCode", label: "zip02" },
    { field: "workPlaceInfo.prefectureCode", label: "prefectureCode" },
    { field: "workPlaceInfo.departmentName", label: "departmentName" },
  ];

  const HomePlaceFields = [
    { field: "profile.phoneNumber", label: "homePhone03" },
    { field: "profile.address.city", label: "city" },
    { field: "profile.address.line", label: "line" },
    { field: "profile.address.postalCode", label: "homeZip02" },
    { field: "profile.address.prefectureCode", label: "prefectureCode" },
  ];

  useEffect(() => {
    if (event_id) {
      handleFetchEventSessionEntries();
    }
    if (event) {
      handleFetchEventMicroCMS();
    }
  }, [event_id, event]);

  useEffect(() => {
    const metaTags = [
      {
        name: "keywords",
        content:
          "宣伝,広告,コピーライター,教育講座,SP,プロモーション,販売促進,クリエイティブ,クリエーティブ,デザイン,広報,PR,IR,編集,ライティング,環境,哲学,宣伝会議,販促会議,ブレーン,編集会議,PRIR,環境会議,人間会議,コピーライター養成講座,編集ライター養成講座,アドバタイムズ。",
      },
      {
        name: "description",
        content:
          "宣伝会議のwebサイト。広告宣伝・販促SP・広報PR・編集・広告クリエイティブなどの、出版事業と教育事業を展開しています。",
      },
    ];

    metaTags.forEach(({ name, content }) => {
      let tag = document.querySelector(
        `meta[name="${name}"]`
      ) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);

  useEffect(() => {
    if (display_mode === 2) {
      setTimeout(() => {
        // navigate(Routes.USER)
        const urlParams = new URLSearchParams(window.location.search);
        const event_id = urlParams.get("event");
        const urlReturn = urlParams.get("urlReturn") ?? "";
        if(urlReturn && urlReturn !== "") {
          window.location.href = urlReturn;
        } else {
          window.location.href = event_id
            ? `${appConfig.SPA_EVENT_WEB}/marketing/event/${event_id}`
            : `${appConfig.SPA_EVENT_WEB}/marketing/event`;
        }
      }, 20000);
    }
  }, [display_mode]);

  useEffect(() => {
    if (survey_web_url_id && !dataEdit) {
      handleFetchSurveyId();
      handleFetchUserHashId();
    }
  }, [survey_web_url_id]);

  useEffect(() => {
    // ユーザー情報をglobalStateから取得してセット（user/settingと同じ方式）
    const initializeUserData = () => {
      const { user_metadata } = globalState.user || {};
      
      if (user_metadata && !dataEdit) {
        const user_metadata_with_newsletter = applyNewsletterDefaults(user_metadata);
        setState((prevState) => ({
          ...prevState,
          userMetaDataDetail: user_metadata_with_newsletter,
          userMetaData: user_metadata_with_newsletter,
        }));
      }
    };
    if (globalState.user) {
      initializeUserData();
    }
  }, [globalState.user])

  useEffect(() => {
    if (survey_id) {
      handleFetchSurveyDetail();
    }
    localStorage.removeItem("survey_url");
  }, [survey_id]);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      isAgreeTerms: agreeTerms,
    }));
  }, [agreeTerms]);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      isAgreements: agreements,
    }));
  }, [agreements]);

  useEffect(() => {
    if (
      userMetaData?.profile?.contactType === 1 ||
      userMetaData?.profile?.contactType === 2
    ) {
      setState((prevState) => ({
        ...prevState,
        userMetaDataDetail: userMetaData,
      }));
    }
  }, [userMetaData?.profile?.contactType]);

  useEffect(() => {
    if (dataEdit) {
      console.log("dataEdit", dataEdit);
      setState((prevState) => ({
        ...prevState,
        isFirstTimeSetting: false,
        userMetaDataDetail: dataEdit,
        userMetaData: dataEdit,
        surveyData: questionData
      }));
    }
  }, [dataEdit]);


  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      answerData: answerDataEdit,
    }));
  }, [answerDataEdit]);

  const handleFetchSurveyId = async () => {
    setStateValue("loader", true);
    try {
      const result = await getSurveyId(survey_web_url_id ?? "");
      if (result) {
        set_survey_id(result.data.surveyId);
      }
    } catch (err) {
      return err;
    } finally {
      setStateValue("loader", false);
    }
  };

  const handleFetchUserHashId= async () => {
    try {
      const response = await fetchUserInfoProxy(1);
      const user_metadata = response?.data
      const user_id_hash = user_metadata?.user_id_hash ?? "";
      const auth0_user_id = user_metadata?.auth0_user_id ?? "";

      if(response?.status == 200) {
        if (user_id_hash) {
          set_user_hash(user_id_hash ?? "");
          set_user_id(auth0_user_id ?? "");
        }
      }
    } catch (err) {
      return err;
    }
  };

  const handleFetchSurveyDetail = async () => {
    setStateValue("loader", true);
    try {
      const result = await getSurveyDetail(survey_id ?? "");
      if (result) {
        setState((prevState) => ({
          ...prevState,
          surveyData: result.data.data as ISurveyDetail,
        }));
      }
    } catch (err) {
      return err;
    } finally {
      setStateValue("loader", false);
    }
  };

  const handleRegistSession = async () => {
    setStateValue("loader", true);
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const session_id = urlParams.get("session_id");
      const event_id = urlParams.get("event_id");
      const plans = urlParams.get("plans");
      const result = await registerSession(event_id ?? "", session_id ?? "", plans ?? "", false);

      if (result.data.statusCode === 200) {
        set_display_mode(2);
      } else if (result.data.statusCode === 202) {
        navigate(`${Routes.SURVEY_ANSWER_FINISH}?${urlParams.toString()}`, {
          state: {
            title: "",
            responseCode: 400,
            noti: "",
            note: "お手続き完了のため、チケットの購入へお進みください。",
            mess: "ご入力ありがとうございます。",
            hint: "登録はまだ完了しておりません。",
            url: result.data.url,
            checkPlans: true,
          },
        });

      } else if (result.data.statusCode === 500) {
        let noti = "登録できませんでした";
        let mess = "";
        let hint = "詳細はイベント情報をご確認ください。";
        if (result.data?.body?.includes("Registration deadline has passed")) {
          mess = "セッションの受付は終了しました。";
        } else if (
          result.data?.body?.includes("Event registration has not started yet")
        ) {
          mess = "イベントの登録期間前です。";
        } else if (
          result.data?.body?.includes("Event registration has closed")
        ) {
          mess = "イベントの登録期間が終了しました。";
        } else {
          noti = "登録できませんでした";
          mess = "申込登録に失敗しました。";
          hint = "詳細はお問い合わせください。";
        }
        set_content({
          noti,
          mess,
          hint,
        });
        set_display_mode(2);
      }
    } catch (error) {
      const urlParams = new URLSearchParams(window.location.search);
      navigate(`${Routes.SURVEY_ANSWER_FINISH}?${urlParams.toString()}`, {
        state: {
          title: state.dataMicroCMS?.title,
          responseCode: 500,
          noti: "登録できませんでした",
          mess: "申込登録に失敗しました。",
          hint: "詳細はお問い合わせください。",
        },
      });
    } finally {
      setStateValue("loader", false);
    }
  };

  const handleFetchEventSessionEntries = async () => {
    setStateValue("loader", true);
    try {
      const result = await getEventSessionEntries(event_id ?? "");
      setState((prevState) => ({
          ...prevState,
          ondemand: result.data.data?.ondemand,
        }));
      if (result && result.data.data?.answered) {
        await handleRegistSession();
      } else {
        set_display_mode(1);
      }
    } catch (err) {
      return err;
    } finally {
      setStateValue("loader", false);
    }
  };

  const handleFetchEventMicroCMS = async () => {
    try {
      const result = await getEventMicroCMS(event ?? "");
      if (result) {
        setState((prevState) => ({
          ...prevState,
          dataMicroCMS: result.data.data,
        }));
        document.title = `【入力画面】 参加お申込みフォーム ${result.data.data.title}`;
      }
    } catch (err) {
      return err;
    }
  };

  const handleScrollToTop = () => {
    document.documentElement.style.scrollBehavior = "auto";
    setTimeout(() => window.scrollTo(0, 0), 5);
    setTimeout(
      () => (document.documentElement.style.scrollBehavior = "smooth"),
      100
    );
  };

  const handleChangeSubOtherAnswer = (
    page_id: string,
    question_id: string,
    answer_id: string,
    value: string
  ) => {
    setState((prevState) => {
      const updatedPages = answerData?.pages?.map((page) => {
        if (page.id === page_id) {
          const updatedQuestions = page?.questions?.map((question) => {
            if (question.id === question_id) {
              const updatedAnswers = question?.answers?.map((answer) => {
                if (answer.other_id === answer_id) {
                  return { ...answer, text: value };
                }
                return answer;
              });
              return { ...question, answers: updatedAnswers };
            }
            return question;
          });
          return { ...page, questions: updatedQuestions };
        }
        return page;
      });
      const updatedErrors = { ...prevState?.errorMessages };
      delete updatedErrors[question_id ?? ""];
      return {
        ...prevState,
        answerData: { ...prevState.answerData, pages: updatedPages },
        errorMessages: updatedErrors,
      };
    });
  };

  const getSubOtherAnswerText = (
    page_id: string,
    question_id: string,
    answer_id: string
  ) => {
    const page = answerData?.pages?.find((p) => p.id === page_id);
    if (page) {
      const question = page?.questions?.find((q) => q.id === question_id);
      if (question) {
        const answer = question?.answers?.find((a) => a.other_id === answer_id);
        if (answer) {
          return answer.text;
        }
      }
    }
    return "";
  };

  const applyNewsletterDefaults = (userMetaData: any) => {
    const transitionSource = localStorage.getItem("transition_source");
    const isKankyo = userMetaData?.transition_source === "kankyobusiness" || transitionSource === "kankyobusiness";
    const isNotUpdatedUser = userMetaData.user_status === 1 || userMetaData.user_status === 3;
    const mailMagId = localStorage.getItem("mailmagid");
    let dataToSet:  IUserMetaDataApi = { ...userMetaData };

    if (mailMagId) {
      dataToSet = checkNewsletterFromMailmagId(mailMagId, dataToSet);
    }
    if (isNotUpdatedUser) {
      if (isKankyo) {
        return {
          ...dataToSet,
          newsletterSubscription: {
            ...(dataToSet?.newsletterSubscription ?? {}),
            contestsAwards: true,
            editorialBooks: true,
            sendenkaigiInfo: true,
            environmentalBusinessOnline: true,
            environmentalBusinessOnlineNews: true,
          }
        };
      }
      return {
        ...dataToSet,
        newsletterSubscription: {
          ...(dataToSet?.newsletterSubscription ?? {}),
          contestsAwards: true,
          editorialBooks: true,
          sendenkaigiInfo: true,
        }
      }
    } else {
      return {
        ...dataToSet,
        newsletterSubscription: {
          ...(dataToSet?.newsletterSubscription ?? {}),
          contestsAwards: true,
          editorialBooks: true,
          sendenkaigiInfo: true,
        }
      }
    }
  };

  const handleChangeSurveyData = (
    page_id: string,
    dataQuestion: ISurveyQuestion,
    value: string | number | boolean
  ) => {
    setState((prevState) => {
      const updatedAnswerData = prevState.answerData?.pages
        ? [...prevState.answerData.pages]
        : [];
      const pageIndex = updatedAnswerData.findIndex(
        (page) => page.id === page_id
      );

      if (pageIndex === -1) {
        const otherChoiceId = dataQuestion.answers?.other?.id?.toString();
        const answer: IAnswerPageQuestionAnswers[] =
          dataQuestion.family === "open_ended"
            ? [{ text: value?.toString() }]
            : otherChoiceId === value.toString()
            ? [{ other_id: value?.toString() }]
            : [{ choice_id: value?.toString() }];

        updatedAnswerData.push({
          id: page_id,
          questions: [
            {
              id: dataQuestion.id,
              answers: answer,
            },
          ],
        });
      } else {
        const page = updatedAnswerData[pageIndex];
        const questions = page.questions ?? [];
        const questionIndex = questions.findIndex(
          (question) => question.id === dataQuestion.id
        );

        if (questionIndex === -1) {
          const otherChoiceId = dataQuestion.answers?.other?.id?.toString();
          const answer: IAnswerPageQuestionAnswers[] =
            dataQuestion.family === "open_ended"
              ? [{ text: value?.toString() }]
              : otherChoiceId === value.toString()
              ? [{ other_id: value?.toString() }]
              : [{ choice_id: value?.toString() }];

          questions.push({
            id: dataQuestion.id,
            answers: answer,
          });
        } else {
          let updatedAnswers = [...(questions[questionIndex].answers || [])];

          if (dataQuestion.family === "open_ended") {
            updatedAnswers = value?.toString()
              ? [{ text: value?.toString() }]
              : [];
          } else if (dataQuestion.family === "single_choice") {
            const otherChoiceId = dataQuestion.answers?.other?.id?.toString();
            if(otherChoiceId != value) {
              updatedAnswers = [{ choice_id: value?.toString() }];
            } else {
              updatedAnswers = [{ other_id: value?.toString() }];
            }
          } else {
            const choiceId = value?.toString();
            const otherChoiceId = dataQuestion.answers?.other?.id?.toString();

            if (choiceId === otherChoiceId) {
              const existingOther = updatedAnswers.some(
                (answer) => answer.other_id === otherChoiceId
              );
              if (!existingOther) {
                updatedAnswers.push({ other_id: choiceId });
              } else {
                updatedAnswers = updatedAnswers.filter(
                  (answer) => answer.other_id !== otherChoiceId
                );
              }
            } else {
              const existingChoiceIndex = updatedAnswers.findIndex(
                (answer) => answer.choice_id === choiceId
              );

              if (existingChoiceIndex === -1) {
                updatedAnswers.push({ choice_id: choiceId });
              } else {
                updatedAnswers.splice(existingChoiceIndex, 1);
              }
            }
          }

          questions[questionIndex] = {
            ...questions[questionIndex],
            answers: updatedAnswers,
          };
        }

        const filteredQuestions = questions.filter(q => q.answers && q.answers.length > 0);
        page.questions = filteredQuestions;
      }

      const updatedErrors = { ...prevState?.errorMessages };
      delete updatedErrors[dataQuestion?.id ?? ""];

      return {
        ...prevState,
        answerData: {
          ...prevState.answerData,
          custom_variables: {
            survey_id: survey_id ?? "",
            id: user_hash ?? "",
            user_id: user_id ?? "",
          },
          pages: updatedAnswerData,
        },
        errorMessages: updatedErrors,
      };
    });
  };

  const getNestedValue = <T,>(obj: T | undefined, path: string): any => {
    if (!obj) return undefined;

    const keys = path.split(".");
    let result: any = obj;

    for (const key of keys) {
      if (result && key in result) {
        result = result[key];
      } else {
        return undefined;
      }
    }
    return result;
  };

  const handleAddFields = () => {
    let requiredFields: Field[] = [];

    if(selectedComponents.includes("BasicInfo")){
      requiredFields =[...requiredFields, ...BasicInfoFields]
    }

    if(selectedComponents.includes("PositionInfo")){
      requiredFields =[...requiredFields, ...PositionInfoFields]
    }

    if(selectedComponents.includes("BasicInterests")){
      requiredFields =[...requiredFields, ...BasicInterestsFields]
    }

    if(selectedComponents.includes("WorkPlace")){
      requiredFields =[...requiredFields, ...WorkPlaceFields]
    }

    // if(userMetaDataDetail?.profile?.contactType === 1 && selectedComponents.includes("HomePlace")){
    //   requiredFields =[...requiredFields, ...HomePlaceFields]
    // }

    return requiredFields;
  }

  const handleCheckValidate = () => {
    const {
      // homeZip01,
      // homeZip02,
      zip01,
      zip02,
      mobile01,
      mobile02,
      mobile03,
      phone01,
      phone02,
      phone03,
      fax1,
      fax2,
      fax3,
      // homeMobile01,
      // homeMobile02,
      // homeMobile03,
      // homePhone01,
      // homePhone02,
      // homePhone03,
    } = subContactValue ?? {};

    const { day, month, year } = userMetaData?.profile?.birth ?? {};
    const errors = [];
    const isAnyFilledFax = fax1 || fax2 || fax3;
    const isAllFilledFax = fax1 && fax2 && fax3;

    const isAnyFilledMobile = mobile01 || mobile02 || mobile03;
    const isAllFilledMobile = mobile01 && mobile02 && mobile03;

    // const isAnyFilledHomeMobile = homeMobile01 || homeMobile02 || homeMobile03;
    // const isAllFilledHomeMobile = homeMobile01 && homeMobile02 && homeMobile03;

    // const isAnyFilledHomePhone = homePhone01 || homePhone02 || homePhone03;
    // const isAllFilledHomePhone = homePhone01 && homePhone02 && homePhone03;

    const isAnyFilledWorkPhone = phone01 || phone02 || phone03;
    const isAllFilledWorkPhone = phone01 && phone02 && phone03;

    // const isAnyFilledHomeZip =
    //   (homeZip01 && !homeZip02) || (!homeZip01 && homeZip02);
    // const isAnyFilledWorkZip = (zip01 && !zip02) || (!zip01 && zip02);

    // if (isAnyFilledHomeZip) {
    //   errors.push({
    //     field: "homeZip02",
    //     mess: "自宅郵便番号を正しく入力してください。",
    //   });
    // }

    // if (isAnyFilledWorkZip) {
    //   errors.push({
    //     field: "zip02",
    //     mess: "勤務先郵便番号を正しく入力してください。",
    //   });
    // }

    const currentDate = new Date();
    const inputDate = new Date(year ?? 1901, (month ?? 1) - 1, day);
    if (inputDate > currentDate) {
      errors.push({
        field: "day",
        mess: t("validation.enterValidBirthDate"),
      });
    }
    if (isAnyFilledFax && !isAllFilledFax) {
      errors.push({
        field: "fax3",
        mess: t("validation.enterValidfaxNumber"),
      });
    }
    if (isAnyFilledMobile && !isAllFilledMobile) {
      errors.push({
        field: "mobile03",
        mess: t("validation.enterValidMobileNumber"),
      });
    }

    // if (isAnyFilledHomeMobile && !isAllFilledHomeMobile) {
    //   errors.push({
    //     field: "homeMobile03",
    //     mess: t("validation.enterValidMobileNumber"),
    //   });
    // }

    // if (
    //   userMetaData?.profile?.contactType !== 1 &&
    //   isAnyFilledHomePhone &&
    //   !isAllFilledHomePhone
    // ) {
    //   errors.push({
    //     field: "homePhone03",
    //     mess: t("validation.enterValidMobileNumber"),
    //   });
    // }

    if (
      userMetaData?.profile?.contactType === 1 &&
      isAnyFilledWorkPhone &&
      !isAllFilledWorkPhone
    ) {
      errors.push({
        field: "phone03",
        mess: t("validation.enterValidMobileNumber"),
      });
    }

    const phones = [phone01, phone02, phone03];
    const joinedPhones = phones.join("");
    if (phones.every((phone) => phone)) {
      for (let i = 0; i < phones.length; i++) {
        if (!Regex.RULE.NUMBER.test(phones[i] ?? "")) {
          errors.push({
            field: `phone0${i + 1}`,
            mess: t("validation.landlineNumberOnlyDigits"),
          });
        }
      }
      if (joinedPhones.length > 12) {
        errors.push({
          field: "phone03",
          mess: t("validation.landlineNumberMax12Digits"),
        });
      }
    }

    const faxs = [fax1, fax2, fax3];
    const joinedFaxs = faxs.join("");
    if (faxs.every((fax) => fax)) {
      for (let i = 0; i < faxs.length; i++) {
        if (!Regex.RULE.NUMBER.test(faxs[i] ?? "")) {
          errors.push({
            field: `fax${i + 1}`,
            mess: t("validation.faxNumberOnlyNumbers"),
          });
        }
      }
      if (joinedFaxs.length > 12) {
        errors.push({
          field: "fax3",
          mess: t("validation.landlineFaxMax12Digits"),
        });
      }
    }

    const requiredFields = handleAddFields();

    requiredFields.forEach(({ field, label }) => {
      const fieldValue = getNestedValue(userMetaData, field);

      if (field == "profile.contactType") {
        if (!(fieldValue == 1 || fieldValue == 2)) {
          errors.push({
            field: label,
            mess: t("common.required"),
          });
        }
      } else if (
        field == "profile.birth.year" ||
        field == "profile.birth.month" ||
        field == "profile.birth.day"
      ) {
        if (!fieldValue || fieldValue == 0) {
          errors.push({
            field: label,
            mess: t("common.required"),
          });
        }
      } else if (!fieldValue || fieldValue.length === 0) {
        errors.push({
          field: label,
          mess: t("common.required"),
        });
      }
    });

    return errors;
  };

  const handleScrollToID = (id: string) => {
    document.documentElement.style.scrollBehavior = "auto";
    const element = document.getElementById(id);
    if (element) {
      setTimeout(() => {
        window.scrollTo({
          top: element.offsetTop - 50,
          behavior: "smooth",
        });
      }, 5);
    }

    setTimeout(() => {
      document.documentElement.style.scrollBehavior = "smooth";
    }, 100);
  };

  const handleConfirm = () => {
    const messErr = handleCheckValidate();
    let errors: { [key: string]: string } = {};
    surveyData?.pages?.forEach((page) => {
      page.questions?.forEach((question) => {
        const answersLegnth = answerData?.pages
          ?.find((p) => p.id === page.id)
          ?.questions?.find((q) => q.id === question.id)?.answers?.length;

        if (question.required && !answersLegnth) {
          const id = question.id ?? "";
          errors[id] = question.required.text ?? "";
        }

        const answers = answerData?.pages
          ?.find((p) => p.id === page.id)
          ?.questions?.find((q) => q.id === question.id)?.answers;

        answers?.forEach((answer) => {
          if (answer?.other_id && !answer.text) {
            const id = question.id ?? "";
            errors[id] = question.answers?.other.error_text ?? "";
          }
        });
      });
    });

    if (messErr.length > 0) {
      const fieldErrorMapping: { [key: string]: string } = {
        //BasicInfo
        first_name: "BasicInfo",
        last_name: "BasicInfo",
        first_name_kana: "BasicInfo",
        last_name_kana: "BasicInfo",
        occupationCode: "BasicInfo",
        year: "BasicInfo",
        month: "BasicInfo",
        day: "BasicInfo",
        contactType: "BasicInfo",
        //PositionInfo
        positionCode: "PositionInfo",
        affiliationCodes: "PositionInfo",
        //BasicInterests
        jobCodes: "BasicInterests",
        environmentBusinessCodes: "BasicInterests",
        //WorkPlace
        companyName: "WorkPlace",
        zip01: "WorkPlace",
        zip02: "WorkPlace",
        phone03: "WorkPlace",
        departmentName: "WorkPlace",

        //HomePlace
        // homeZip01: "HomePlace",
        // homeZip02: "HomePlace",
        // homePhone03: "HomePlace",

        //Work&Home
        prefectureCode: "WorkPlace",
        city: "WorkPlace",
        line: "WorkPlace",
      };

      const orderedMessErr = messErr.sort((a, b) => {
        const aIndex = Object.keys(fieldErrorMapping).indexOf(a.field);
        const bIndex = Object.keys(fieldErrorMapping).indexOf(b.field);

        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;

        return aIndex - bIndex;
      });

      const fieldError = orderedMessErr.find(
        (item) => fieldErrorMapping[item.field]
      );

      let id: string = fieldError ? fieldErrorMapping[fieldError.field] : "";
      //check Work&Home
      // if (userMetaData?.profile?.contactType === 1) {
      //   if (
      //     ["prefectureCode", "city", "line"].includes(fieldError?.field || "")
      //   ) {
      //     id = "WorkPlace";
      //   }
      // }
      handleScrollToID(id);
      setState((prevState) => ({
        ...prevState,
        preview: false,
        errorMess: messErr,
      }));
    }

    if (Object.keys(errors).length > 0) {
      handleScrollToID("Survey")
      setState((prevState) => ({
        ...prevState,
        errorMessages: errors,
      }));
    }

    if (Object.keys(errors).length === 0 && messErr.length === 0) {
      setState((prevState) => ({
        ...prevState,
        preview: true,
      }));
      const urlParams = new URLSearchParams(window.location.search).toString();
      navigate(
        `${Routes.SURVEY_ANSWER_CONFIRM.replace(
          ":survey_web_url_id",
          survey_web_url_id ?? ""
        )}?${urlParams}`,
        {
          state: {
            data: userMetaData,
            answerData,
            agreeTerms: isAgreeTerms,
            agreements:isAgreements,
            questionData: surveyData,
            title: state.dataMicroCMS?.title,
          },
        }
      );
      handleScrollToTop();
    }
  };

  const renderFieldQuestion = (
    family: string,
    subtype: string,
    data: ISurveyQuestion,
    page_id: string
  ) => {
    const errorMessage = errorMessages[data?.id ?? ""];
    switch (family) {
      case "open_ended":
        return (
          <>
            <TextField
              fullWidth
              key={data.id}
              value={
                answerData?.pages
                  ?.find((page) => page.id === page_id)
                  ?.questions?.find((question) => question.id === data.id)
                  ?.answers?.[0]?.text ?? ""
              }
              size="small"
              multiline={subtype == "essay" ? true : false}
              rows={subtype == "essay" ? 4 : 1}
              sx={{
                width: "100%",
                "& input": {
                  backgroundColor: errorMessage ? "#ffe6e6" : "transparent",
                },
              }}
              onChange={(e) => {
                handleChangeSurveyData(page_id, data, e.target.value);
              }}
              error={!!errorMessage}
            />
            <p className="error-text" role="alert">
              {errorMessage}
            </p>
          </>
        );
      case "multiple_choice":
        return (
          <FormControl>
            <Box display={"flex"} flexWrap="wrap">
              {data.answers?.choices?.map((item) => (
                <FormControlLabel
                  key={item.id}
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontWeight: "normal",
                      fontSize: 15,
                    },
                    "& .Mui-checked + .MuiFormControlLabel-label": {
                      fontWeight: "bold",
                    },
                  }}
                  control={
                    <Checkbox
                      value={item.id}
                      checked={
                        answerData?.pages
                          ?.find((page) => page.id === page_id)
                          ?.questions?.find(
                            (question) => question.id === data.id
                          )
                          ?.answers?.some(
                            (answer) => answer.choice_id === item.id
                          ) ?? false
                      }
                      onChange={(e) => {
                        handleChangeSurveyData(page_id, data, e.target.value);
                      }}
                      sx={{
                        color: "#009999",
                        "&.Mui-checked": {
                          color: "#009999",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: "15px",
                        },
                      }}
                    />
                  }
                  label={item.text}
                />
              ))}
              {data.answers?.other &&
                (data.answers.other?.is_answer_choice ? (
                  <>
                    <FormControlLabel
                      key={data.answers?.other.id}
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontWeight: "normal",
                          fontSize: 15,
                        },
                        "& .Mui-checked + .MuiFormControlLabel-label": {
                          fontWeight: "bold",
                        },
                      }}
                      control={
                        <Checkbox
                          value={data.answers?.other.id}
                          checked={
                            answerData?.pages
                              ?.find((page) => page.id === page_id)
                              ?.questions?.find(
                                (question) => question.id === data.id
                              )
                              ?.answers?.some(
                                (answer) =>
                                  answer.other_id === data.answers?.other.id
                              ) ?? false
                          }
                          onChange={(e) => {
                            handleChangeSurveyData(
                              page_id,
                              data,
                              e.target.value
                            );
                          }}
                          sx={{
                            color: "#009999",
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                            "& .MuiSvgIcon-root": {
                              fontSize: "15px",
                            },
                          }}
                        />
                      }
                      label={data.answers?.other.text}
                    />
                    <TextField
                      fullWidth
                      key={data.id}
                      disabled={
                        !answerData?.pages
                          ?.find((page) => page.id === page_id)
                          ?.questions?.find(
                            (question) => question.id === data.id
                          )
                          ?.answers?.some(
                            (answer) =>
                              answer.other_id === data.answers?.other.id
                          )
                      }
                      size="small"
                      multiline={subtype == "essay" ? true : false}
                      rows={subtype == "essay" ? 4 : 1}
                      sx={{
                        width: "100%",
                        "& input": {
                          backgroundColor: errorMessage
                            ? "#ffe6e6"
                            : "transparent",
                        },
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: !answerData?.pages
                            ?.find((page) => page.id === page_id)
                            ?.questions?.find(
                              (question) => question.id === data.id
                            )
                            ?.answers?.some(
                              (answer) =>
                                answer.other_id === data.answers?.other.id
                            )
                            ? "whitesmoke"
                            : "transparent",
                        },
                      }}
                      value={getSubOtherAnswerText(
                        page_id,
                        data?.id ?? "",
                        data.answers?.other?.id ?? ""
                      )}
                      onChange={(e) => {
                        handleChangeSubOtherAnswer(
                          page_id,
                          data?.id ?? "",
                          data.answers?.other?.id ?? "",
                          e.target.value
                        );
                      }}
                      error={!!errorMessage}
                    />
                  </>
                ) : (
                  <>
                    <FormControlLabel
                      key={data.answers?.other.id}
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontWeight: "normal",
                          fontSize: 15,
                        },
                        "& .Mui-checked + .MuiFormControlLabel-label": {
                          fontWeight: "bold",
                        },
                      }}
                      control={
                        <Checkbox
                          value={data.answers?.other.id}
                          checked={
                            answerData?.pages
                              ?.find((page) => page.id === page_id)
                              ?.questions?.find(
                                (question) => question.id === data.id
                              )
                              ?.answers?.some(
                                (answer) =>
                                  answer.choice_id === data.answers?.other.id
                              ) ?? false
                          }
                          onChange={(e) => {
                            handleChangeSurveyData(
                              page_id,
                              data,
                              e.target.value
                            );
                          }}
                          sx={{
                            color: "#009999",
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                            "& .MuiSvgIcon-root": {
                              fontSize: "15px",
                            },
                          }}
                        />
                      }
                      label={data.answers?.other.text}
                    />
                  </>
                ))}
            </Box>
            <p className="error-text" role="alert">
              {errorMessage}
            </p>
          </FormControl>
        );

      case "single_choice":
        return (
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={
                answerData?.pages
                  ?.find((page) => page.id === page_id)
                  ?.questions?.find((question) => question.id === data.id)
                  ?.answers?.[0]?.choice_id ?? ""
              }
              onChange={(e) => {
                handleChangeSurveyData(page_id, data, e.target.value);
              }}
            >
              {data.answers?.choices?.map((item) => {
                return (
                  <>
                    <FormControlLabel
                      key={item.id}
                      control={
                        <Radio
                          value={item.id}
                          size="small"
                          checked={
                            answerData?.pages
                              ?.find((page) => page.id === page_id)
                              ?.questions?.find(
                                (question) => question.id === data.id
                              )
                              ?.answers?.some(
                                (answer) => answer.choice_id === item.id
                              ) ?? false
                          }
                          sx={{
                            color: "#009999",
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                            "& .MuiSvgIcon-root": {
                              fontSize: "15px",
                            },
                          }}
                        />
                      }
                      label={item.text}
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontWeight: "normal",
                          fontSize: 15,
                        },
                        "& .Mui-checked + .MuiFormControlLabel-label": {
                          fontWeight: "bold",
                        },
                      }}
                    />
                  </>
                );
              })}
              {data.answers?.other && data.answers.other?.is_answer_choice && (
                <Box sx={{width: '100%'}}>
                  <>
                    <FormControlLabel
                      key={data.answers?.other.id}
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontWeight: "normal",
                          fontSize: 15,
                        },
                        "& .Mui-checked + .MuiFormControlLabel-label": {
                          fontWeight: "bold",
                        },
                      }}
                      control={
                        <Radio
                          value={data.answers?.other.id}
                          size="small"
                          checked={
                            answerData?.pages
                              ?.find((page) => page.id === page_id)
                              ?.questions?.find(
                                (question) => question.id === data.id
                              )
                              ?.answers?.some(
                                (answer) => answer.other_id === data.answers?.other.id
                              ) ?? false
                          }
                          sx={{
                            color: "#009999",
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                            "& .MuiSvgIcon-root": {
                              fontSize: "15px",
                            },
                          }}
                        />
                      }
                      label={data.answers?.other.text}
                    />
                    <TextField
                      fullWidth
                      key={data.id}
                      disabled={
                        !(answerData?.pages
                          ?.find((page) => page.id === page_id)
                          ?.questions?.find(
                            (question) => question.id === data.id
                          )
                          ?.answers?.some(
                            (answer) => answer.other_id === data.answers?.other.id
                          ))
                      }
                      size="small"
                      multiline={subtype == "essay" ? true : false}
                      rows={subtype == "essay" ? 4 : 1}
                      sx={{
                        width: "100%",
                        "& input": {
                          backgroundColor: errorMessage
                            ? "#ffe6e6"
                            : "transparent",
                        },
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: 
                            !(answerData?.pages
                            ?.find((page) => page.id === page_id)
                            ?.questions?.find(
                              (question) => question.id === data.id
                            )
                            ?.answers?.some(
                              (answer) => answer.other_id === data.answers?.other.id
                            ))
                            ? "whitesmoke"
                            : "transparent",
                        },
                      }}
                      value={getSubOtherAnswerText(
                        page_id,
                        data?.id ?? "",
                        data.answers?.other?.id ?? ""
                      )}
                      onChange={(e) => {
                        handleChangeSubOtherAnswer(
                          page_id,
                          data?.id ?? "",
                          data.answers?.other?.id ?? "",
                          e.target.value
                        );
                      }}
                      error={!!errorMessage}
                    />
                  </>
                </Box>
              )}
            </RadioGroup>
            <p className="error-text" role="alert">
              {errorMessage}
            </p>
          </FormControl>
        );
    }
  };

  const renderQuestion = (page: ISurveyPage) => {
    return (
      <>
        {page?.questions?.map((question) => {
          return (
            <tr key={question.id}>
              <th className="font-w">
                <div
                  dangerouslySetInnerHTML={{
                    __html: question.headings?.[0].heading ?? "",
                  }}
                />
              </th>
              <td>
                {renderFieldQuestion(
                  question.family ?? "",
                  question.subtype ?? "",
                  question,
                  page.id ?? ""
                )}
              </td>
            </tr>
          );
        })}
      </>
    );
  };

  return (
    <>
      {display_mode === 1 && (
        <Box className="survey_answer-page mt20">
          <div className="col-md-12 mb-4">
            <p className="required-title">
              下記お申込みフォームにご入力をお願いします。
              <br />※
              ご入力いただいた内容でお申込みを行ないますので、お間違いにご注意ください。
            </p>
          </div>

          <div className="row mt-4">
            <div className="col-md-12">
              <h2>個人情報の取扱い</h2>
              {dataMicroCMS?.privacy_policy ? (
                <div
                  className="privacy-information"
                  dangerouslySetInnerHTML={{
                    __html: dataMicroCMS?.privacy_policy ?? "",
                  }}
                ></div>
              ) : (
                <div className="privacy-information">
                  <p className="title">
                    <strong>
                      セミナーおよびイベントで取得した個人情報について
                    </strong>
                  </p>
                  <p>
                    弊社の協力・主催するセミナー・イベントでは、お申込時にフォームにお客様の情報をご入力いただいた上で、会場で開催する場合は開催当日に会場受付にてお名刺を頂戴いたします。
                    <br />
                    ご入力いただいたセミナー・イベントの申込フォームおよび会場で取得した名刺の全ての項目のデータは、各セミナー・イベントの運営のために利用する他、商品、サービスなどに関する情報をお送りするために、弊社(株式会社宣伝会議)と、セミナー・イベントを協力・主催する企業とで共同利用いたします。その際、当該個人情報は弊社及び協力・主催する企業様のプライバシーポリシーに従い、管理されます。
                  </p>
                  <p>
                    <strong>個人情報保護方針</strong>
                  </p>
                  <p>
                    制定日 平成17年4月1日
                    <br />
                    改定日 平成27年10月5日
                    <br />
                    改定日 令和2年9月28日
                    <br />
                    株式会社 宣伝会議
                    <br />
                    取締役社長　東 彦弥
                  </p>
                  <p>
                    株式会社宣伝会議（以下「当社」といいます）は、出版・教育・広告マーケティング業務において当社が取り扱う全ての個人情報の保護について、社会的使命を十分に認識し、本人の権利の保護、個人情報に関する法規制等を遵守します。また、以下に示す方針を具現化するための個人情報保護マネジメントシステムを構築し、最新のIT技術の動向、社会的要請の変化、経営環境の変動等を常に認識しながら、その継続的改善に、全社を挙げて取り組むことをここに宣言します。
                  </p>
                  <ol>
                    <li>
                      個人情報は出版・教育・広告マーケティング業務において当社の正当な事業遂行上並びに従業員の雇用、人事管理上必要な範囲に限定して、取得・利用及び提供をし、特定された利用目的の達成に必要な範囲を超えた個人情報の取扱いを行わないための措置を講じます。
                    </li>
                    <li>
                      個人情報保護に関する法令、国が定める指針及びその他の規範を遵守致します。
                    </li>
                    <li>
                      個人情報の漏えい、滅失、き損などのリスクに対しては、合理的な安全対策を講じて防止すべく事業の実情に合致した経営資源を注入し個人情報セキュリティ体制を継続的に向上させます。また、万一の際には速やかに是正措置を講じます。
                    </li>
                    <li>
                      個人情報取扱いに関する苦情及び相談に対しては、迅速かつ誠実に、適切な対応をさせていただきます。
                    </li>
                    <li>
                      個人情報保護マネジメントシステムは、当社を取り巻く環境の変化を踏まえ、適時・適切に見直してその改善を継続的に推進します。
                    </li>
                  </ol>
                  <p>
                    本方針は、全ての従業者に配付して周知させるとともに、当社のホームページ、パンフレットなどに掲載することにより、いつでもどなたにも入手可能な措置を取るものとします。
                  </p>
                  <p>
                    <strong>【お問合せ窓口】</strong>
                    <br />
                    個人情報保護方針に関するお問合せにつきましては、下記窓口で受付けております。
                  </p>
                  <address className="well">
                    <p>
                      〒107-8550 東京都港区南青山3-11-13 新青山東急ビル9F
                      <br />
                      株式会社 宣伝会議 コンプライアンス室（総務部内）
                      個人情報問い合わせ係
                      <br />
                      メールアドレス:
                      <a href="mailto:compliance@sendenkaigi.co.jp">
                        compliance@sendenkaigi.co.jp
                      </a>
                      <br />
                      TEL:03-3475-3010 （受付時間 9:00～18:00※）
                      <br />
                      ※土・日曜日、祝日、年末年始、ゴールデンウィーク期間は翌営業日以降の対応とさせていただきます。
                    </p>
                  </address>
                  <p>
                    <strong>
                      プライバシーポリシー（個人情報の取扱いについて）
                    </strong>
                  </p>
                  <ol>
                    <li>
                      <strong>事業者の名称</strong>
                      <br />
                      株式会社 宣伝会議
                    </li>
                    <li>
                      <p>
                        <strong>
                          管理者（若しくはその代理人）の氏名又は職名、所属及び連絡先
                        </strong>
                      </p>
                      <p>
                        管理者名: 個人情報保護管理者 コンプライアンス室 室長
                        <br />
                        所属部署: 株式会社 宣伝会議 総務部
                        <br />
                        連絡先: 電話03-3475-3010
                        <br />
                        <br />
                        個人情報の取扱体制や講じている措置の内容:
                        <br />
                        当社では、個人情報保護管理者を任命し、全社的な体制で個人情報の取扱いを行っています。また、プライバシーマーク認定を取得しJISQ15001:2017の要求事項に準じた措置を講じています。
                      </p>
                    </li>
                    <li>
                      <p>
                        <strong>個人情報の利用目的</strong>
                      </p>
                      <div className="well">
                        <p>
                          {" "}
                          <strong>お客様情報</strong>
                        </p>
                        <p>
                          （1）お客様の氏名、住所、電話番号をご購入いただいた商品の発送、アフターサービスの提供のために利用します。
                          <br />
                          （2）ウェビナー、教育講座オンライン動画の視聴データを分析し当社サービスの改善のために利用します。
                          <br />
                          （3）お客様の当社ウェブサイトの閲覧履歴、購買履歴を蓄積して分析し、以下の目的で利用します。
                        </p>
                        <ul>
                          <li>
                            お客様に最適な商品をウェブサイト上でご提案するため
                          </li>
                          <li>
                            当社および当社の提携先の商品・サービスのご案内のため
                          </li>
                        </ul>
                        <p>
                          <strong>
                            株主情報：氏名、住所、電話番号等の連絡先を以下の目的で使用します。
                          </strong>
                        </p>
                        <p>情報公開、配布物の送付、連絡のため</p>
                        <p>
                          <strong>
                            取引先情報：氏名、会社名、取引情報、住所、電話番号等の連絡先を以下の目的で使用します。
                          </strong>
                        </p>
                        <p>
                          商談及び業務上の諸連絡、受発注業務、請求支払業務のため
                        </p>
                        <p>
                          <strong>社員情報</strong>
                        </p>
                        <p>
                          （1）
                          氏名、電話番号、住所、メールアドレス等を業務連絡、業務管理、セキュリティ管理のために利用します。
                          <br />
                          （2）
                          業務実績、経歴、資格、人事考課等の情報、家族情報等を蓄積、分析し、当社規程に基づき、報酬の決定、人事考課、配属先の決定のために利用します。
                          <br />
                          （3）
                          健康診断結果、身体測定記録、診断書等により、健康的な就業状態の確保、労働者による適正な健康管理のため、病気療養による長期休暇への対応のために利用します。
                        </p>
                        <p>
                          <strong>採用応募者に関する個人情報</strong>
                        </p>
                        <p>
                          （1）氏名、電話番号、住所、メールアドレス等を採用応募者への連絡と当社の採用業務管理のために利用します。
                        </p>
                        <p>
                          （2）経歴、資格、面接結果等を採用の検討のために利用します。{" "}
                        </p>
                        <p>
                          <strong>
                            データベース事業者から入手した情報やインターネットなど公開されている個人情報
                          </strong>
                        </p>
                        <p>以下の目的で本人にアクセスすることがあります</p>
                        <ul>
                          <li>
                            商品、サービスに関する情報の提供および提案のため
                          </li>
                          <li>
                            雑誌・書籍、セミナー、その他イベントに関する案内等のため
                          </li>
                          <li>その他、有益と思われる情報の提供のため</li>
                        </ul>
                      </div>
                      <p>
                        個人情報を集計し、あるいは個人が識別・特定できないように加工したものを作成して、分析や研究、新規サービスの開発に利用する場合があります。個人を特定できない統計データについては、弊社は制限なく利用します。
                      </p>
                    </li>
                    <li>
                      <strong>個人情報の第三者提供</strong>
                      <br />
                      ご記入いただいた個人情報は、法令に基づく場合のほか、弊社または各セミナーおよびイベントを協力あるいは主催する企業が、それぞれのプライバシーポリシーの定める要領にしたがって、第三者又は外部委託先に提供する場合がございます。
                    </li>
                    <li>
                      <strong>個人情報取扱いの委託</strong>
                      <br />
                      当社は事業運営上、お客様により良いサービスを提供するために業務の一部を外部に委託しています。業務委託先に対しては、個人情報を預けることがあります。この場合、個人情報を適切に取り扱っていると認められる委託先を選定し、契約等において個人情報の適正管理・機密保持などによりお客様の個人情報の漏洩防止に必要な事項を取決め、適切な管理を実施させます。
                    </li>
                    <li>
                      <strong>個人情報の開示等の請求</strong>
                      <br />
                      お客様は、当社に対してご自身の個人情報の開示等（利用目的の通知、開示、内容の訂正・追加・削除、利用の停止または消去、第三者への提供の停止）に関して、当社問合わせ窓口に申し出ることができます。その際、当社はお客様ご本人を確認させていただいたうえで、合理的な期間内に対応いたします。開示等の申し出の詳細につきましては、当社ホームページ掲載の「
                      <a
                        href="https://www.sendenkaigi.com/privacy/privacy-open.php"
                        target="_blank"
                      >
                        保有個人データの開示請求手続きについて
                      </a>
                      」をご覧ください。
                    </li>
                    <li>
                      <strong>個人情報を提供されることの任意性について</strong>
                      <br />
                      お客様が当社に個人情報を提供されるかどうかは、お客様の任意によるものです。ただし、必要な項目をいただけない場合、各サービス等が適切な状態で提供できない場合があります。
                    </li>
                    <li>
                      <strong>
                        クッキーその他の個人を特定できない情報について
                      </strong>
                      <br />
                      当社は、当社ウェブサイトの利便性向上、品質向上や行動ターゲティング広告を目的に、ウェブサイトの利用状況を把握するためにクッキー（Cookie）を使用しております。収集された情報は、個人が特定されない形で分析されます。詳細については別に定めるインフォマティブデータの取扱いについてをご参照ください。
                      <br />
                      <br />
                      クッキー等の個人関連情報については、第三者に提供する場合があります。その際、提供先において、個人情報として取得する可能性があります。提供先において、個人関連情報の提供を受けて本人が識別される個人として情報として取得することに同意の上ご利用ください。
                      <br />
                      <br />
                      尚、インターネット利用者が使用するコンピュータ（ブラウザ）では、その設定を変更することにより、当サービスが発行したクッキーを削除することができます。また、設定を変更することにより、クッキーの機能を無効にすることができます。ただし、その結果、ウェブサイト上のサービスの全部または一部が利用できなくなる場合がありますので、あらかじめご了承ください。
                    </li>
                    <li>
                      <p>
                        <strong>情報の共同利用</strong>
                        <br />
                        当社は、キャリナビ利用者および企業の求人求職の結合可能性を高める目的のため、当社グループ会社である「株式会社マスメディアン」（有料職業紹介事業者
                        厚生労働大臣許可：13-ユ-040475）との業務提携契約に基づき、下記の方法等で個人情報を共同利用することがあります。
                        <br />
                        利用目的：両社の利用者および企業の間の求人求職マッチングを高めるため（当社またはマスメディアンのサービスの案内を含む）、就職講座、スキルアップ講座、雑誌・書籍の情報等の案内のため
                        <br />
                        共同利用者の範囲：株式会社マスメディアン
                        <br />
                        利用・取得方法：当社が直接取得した個人情報および求人情報等を、専用通信回線によるデータベースを閲覧する方法等によって共同利用する
                        <br />
                        共同利用における個人情報の管理責任者：当社個人情報管理責任者
                        <br />
                        共同利用する個人情報項目：マスナビ利用者の登録データ{" "}
                      </p>
                    </li>
                    <li>
                      <strong>認定個人情報保護団体について</strong>
                      <br />
                      当社が加入する認定個人情報保護団体は、ありません。{" "}
                    </li>
                    <li>
                      <strong>利用者様自ら開示・記入した情報について</strong>
                      <br />
                      株式会社宣伝会議の各サイトの中には、チャット（会話）やフォーラム（会議室）、掲示板、ニュース・グループ、コメント投稿、電子メール交換などのサービスを提供する場合があります。こうしたサービス内でご利用者様自ら開示・記入した情報は公開情報となりますので、ご注意ください。
                    </li>
                    <li>
                      <strong>外部リンクについて</strong>
                      <br />
                      株式会社宣伝会議の各サイトは、外部のサイトへのリンクを含んでいる場合があります。リンク先サイトでの個人情報の取り扱いについては、当該リンク先サイトにてご自身でご確認ください。このような外部ウェブサイトにおいての個人情報保護の取扱いやサイトの内容に関して株式会社宣伝会議では責任を負いかねますのでご注意ください。
                    </li>
                  </ol>
                  <p>
                    <strong>【お問合せ窓口】</strong>
                    <br />
                    お客様の個人情報に関するお問合せにつきましては、下記窓口で受付けております。
                  </p>
                  <address className="well">
                    <p>
                      〒107-8550 東京都港区南青山3-11-13 新青山東急ビル9F
                      <br />
                      株式会社 宣伝会議 コンプライアンス室（総務部内）
                      個人情報問い合わせ係
                      <br />
                      メールアドレス:
                      <a href="mailto:compliance@sendenkaigi.co.jp">
                        compliance@sendenkaigi.co.jp
                      </a>
                      <br />
                      TEL:03-3475-3010 （受付時間 9:00～18:00※）
                      <br />
                      ※土・日曜日、祝日、年末年始、ゴールデンウィーク期間は翌営業日以降の対応とさせていただきます。
                    </p>
                  </address>
                  <p>
                    <strong>インフォマティブデータの取扱いについて</strong>
                  </p>
                  <p>
                    当社では、当社が運営する『Sendenkaigi Ad
                    Platform』の広告配信プログラム（以下、本サービスといいます。）におきまして、ユーザーの皆様に本サービスをより一層便利にお使いいただけるように、趣味・嗜好等に合わせた広告を表示する『行動ターゲティング広告』を配信しています。
                  </p>
                  <p>
                    当社の『行動ターゲティング広告』は、当社の提携事業者や本サービスの利用事業者が運営、管理するウェブサイトや（以下、対象サイトといいます。）を訪問したユーザー（以下、ユーザーといいます。）から取得した、インフォマティブデータを基にして配信をしています。
                  </p>
                  <p>
                    インフォマティブデータ（※1）とは、ユーザーを識別することができるクッキー（※2）及び広告配信用の識別子（Identification
                    For Advertisers(以下「IDFA」)、Google Advertising
                    ID（※3）、Treasure Data global
                    ID）や、それらを利用して取得した行動履歴情報、取得した情報を分析したデータのことをいいます。
                  </p>
                  <p>
                    ※1.
                    インフォマティブデータにはユーザー個人を特定する住所、氏名、生年月日及び電話番号、端末固有番号の情報は含まれておりません。
                  </p>
                  <p>
                    ※2.
                    クッキーとは、ユーザーが利用するブラウザ毎に、コンピュータ端末等（モバイル、タブレット、その他デバイスを含む）に保存されるテキストファイル（文字情報）です。クッキーは、テキストファイルのためクッキーを利用してのプログラム実行や、コンピュータにウイルスを配信することはありません。
                  </p>
                  <p>
                    ※3. IDFA、Google Advertising
                    IDとは、モバイルアプリケーションなどのクッキーが保存されない環境において、各モバイル端末等に発行される広告配信用の識別子です。
                    IDFAは、iOSに発行される広告用のID、Google Advertising
                    IDとは、Android OSに発行される広告用のIDとなります。
                  </p>
                  <p>
                    当社が取り扱うインフォマティブデータの詳細は以下のとおりです。
                  </p>
                  <ol className="mt15">
                    <li>
                      <strong>
                        インフォマティブデータを取得する事業者の名称
                      </strong>
                      <br />
                      株式会社宣伝会議{" "}
                    </li>
                    <li>
                      <strong>取得するインフォマティブデータの項目</strong>
                      <br />
                      当社が取得するインフォマティブデータ（項目）は、以下のとおりです。
                      <br />
                      <ul>
                        <li>A. クッキーに書き込まれたID</li>
                        <li>B. IDFA及びGoogle Advertising ID</li>
                        <li>
                          C.
                          ユーザーが閲覧したページのURL、及びユーザーが当該ページを閲覧した時刻
                        </li>
                        <li>
                          D.
                          ユーザーが対象サイトを閲覧する際に利用したコンピュータ端末等及びブラウザにかかる情報（IPアドレス及びブラウザ種別を含む）
                        </li>
                        <li>
                          E.
                          リファラー情報（ユーザーが、対象サイトを閲覧する前に経由した当該外部サイトのURL）
                        </li>
                        <li>F. ユーザーが閲覧・購入した商品情報</li>
                      </ul>
                    </li>
                    <li>
                      <strong>
                        インフォマティブデータの取得場所・取得方法
                      </strong>
                      <br />
                      本サービスの対象サイト内に埋め込まれたタグのプログラムを利用して取得します。
                    </li>
                    <li>
                      <strong>インフォマティブデータの利用目的</strong>
                      <br />
                      当社では、インフォマティブデータを、以下の目的のために利用いたします。
                      <br />
                      <ul>
                        <li>
                          A.
                          本サービスにおいて、ユーザーの皆様に、より適切で有効な広告配信をさせていただくために利用いたします。
                          <br />
                          具体的には、ユーザーを識別することで、ユーザー毎の業務領域に合わせた商品及びサービスに関する広告配信や、インターネットをご利用いただいているシステムや端末の仕様に合わせた広告配信、広告の配信頻度の制御を行います。
                        </li>
                        <li>
                          B.
                          本サービスにおいて、ユーザーや、当社の提携事業者、本サービスの利用事業者に対して、広告配信をより効果的に行うための配信ロジックの改善や、本サービス提供における利便性・安全性向上のための機能開発に利用いたします。
                        </li>
                        <li>
                          C.
                          本サービスにおいて、当社の提携事業者、本サービスの利用事業者に対して、提案及び改善を行うための資料や配信結果レポートの作成に利用いたします。
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>インフォマティブデータの保存期間</strong>
                      <br />
                      2年間
                    </li>
                    <li>
                      <strong>インフォマティブデータの第三者提供</strong>
                      <br />
                      当社が取得したインフォマティブデータは、法令で認められた場合、第三者に提供することがあります。
                    </li>
                    <li>
                      <strong>オプトアウトの手段</strong>
                      <br />
                      ユーザーが、インフォマティブデータを利用した行動ターゲティング広告の配信を希望されない場合は、以下のいずれかの方法により、行動ターゲティング広告の広告配信を停止することができます。
                      <br />
                      <ul>
                        <li>
                          Ａ. ウェブサイトの広告配信について（クッキーの場合）
                          <br />
                          <a
                            href="https://www.sendenkaigi.com/dsp/optout/"
                            target="_blank"
                          >
                            オプトアウトページ
                          </a>
                          からオプトアウトクッキーを利用できます。オプトアウトクッキーが保存されているブラウザに対しては、本サービスによる行動ターゲティング広告の配信は行われません。このクッキーによるオプトアウトの有効期限は2038年1月1日となります。
                          <br />
                          ユーザーがこの措置を施したものと異なるブラウザを利用された場合、コンピュータ端末等の買い替えを行われた場合、OSを再インストールされた場合などには、改めてこれらの措置をとっていただかなければなりません。
                        </li>
                        <li>
                          Ｂ. アプリ内の広告配信について（IDFA、Google
                          Advertising IDの場合）
                          <br />
                          IDFA、及びGoogle Advertising
                          IDを利用した広告を制限したい場合はアップル社、グーグル社が各社で提供する案内に従ってください。
                          <br />
                          IDFA（Apple Inc.）：
                          <a
                            href="https://support.apple.com/ja-jp/HT202074"
                            target="_blank"
                          >
                            iAd からの興味関心に基づく広告をオプトアウトする方法
                          </a>
                          <br />
                          （※App Store や Apple News
                          で興味関心に基づく広告の配信を希望しない場合）
                          <br />
                          Google Advertising ID（Google Inc.）：
                          <a
                            href="https://support.google.com/googleplay/answer/3405269?hl=ja"
                            target="_blank"
                          >
                            Google Play＞ヘルプ＞広告 ID
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>個人情報</strong>
                      <br />
                      インフォマティブデータは、個人を特定するものではなく、「個人情報の保護に関する法律」第２条に定める「個人情報」ではありません。
                      <br />
                      なお、当社の「プライバシーポリシー（個人情報の取扱いについて）」については、以下をクリックしてください。
                      <br />
                      <a
                        href="https://www.sendenkaigi.com/privacy/#privacy-policy"
                        target="_blank"
                      >
                        「プライバシーポリシー（個人情報の取扱いについて）」のページはこちらから
                      </a>
                    </li>
                    <li>
                      <strong>インフォマティブデータの安全管理</strong>
                      <br />
                      当社は、一般社団法人日本インタラクティブ広告協会が定める行動ターゲティング広告ガイドラインを遵守しております。
                      <br />
                      インフォマティブデータの取扱いにおいて、インフォマティブデータへの不正アクセス、インフォマティブデータの漏洩、改ざん等を防止するため、厳正な安全管理措置を講じ、また、かかる措置の内容・方法について継続的に見直しを行い、是正、改善に努めます。
                    </li>
                    <li>
                      <strong>お問い合わせ先</strong>
                      <br />
                      インフォマティブデータ及び本書に関するお問い合わせは、
                      <a
                        href="https://www.sendenkaigi.com/inquiry/"
                        target="_blank"
                      >
                        お問い合わせページ
                      </a>
                      より受付をしています。
                    </li>
                    <li>
                      <strong>継続的改善</strong>
                      <br />
                      当社は、インフォマティブデータの適切な取扱いを維持するため、情報の取扱い体制、運用方法を継続的に見なおしてまいります。
                      <br />
                      見直しにあたっては、法令、指針、ガイドライン等の改正・改訂に適合させるのはもとより、ご利用者の声、技術的な変化、セキュリティに関する状況の変化、当社の体制及び事業内容を踏まえて、ご利用者の皆様が安心してお使いいただける体制・運用方法を維持することを第一に考えてまいります。
                    </li>
                    <li>
                      <strong>本ポリシーの改訂等</strong>
                      <br />
                      当社は、本ポリシーの内容を随時変更することができるものとします。
                      <br />
                      変更後のポリシーは、ウェブサイト上で掲示した時点から適用されるものとします。
                    </li>
                  </ol>
                </div>
              )}

              <div className="mt-3 row justify-content-center align-items-center">
                <div className="col-12 col-md d-flex justify-content-center justify-content-md-end">
                  個人情報の取得について
                  <span className="required-icon">必須</span>
                </div>
                <div className="col-12 col-md d-flex justify-content-center justify-content-md-start">
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="personalInformation"
                        checked={isAgreeTerms}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            isAgreeTerms: e.target.checked,
                          }))
                        }
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: "16px",
                          },
                        }}
                        size="small"
                      />
                    }
                    label="同意する"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {surveyData?.pages?.map((page) => {
            return (
              <div className="row mt-5" key={page?.id} id="Survey">
                <div className="col-md-12">
                  <h2>{page?.title}</h2>
                  <div className="row">
                    <div className="col-xs-12">
                      <div className="table-normal">
                        <table className="table">
                          <tbody>{renderQuestion(page)}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          {dataMicroCMS?.agreement && (
            <>
              <strong style={{ fontSize: "16px" }}>
                本イベントへの参加にあたり、以下の事項についてご同意いただきますよう、お願いいたします
                <span style={{ color: "red" }}>【必須】</span>
              </strong>
                <div
                  className="privacy-information"
                  dangerouslySetInnerHTML={{
                    __html: dataMicroCMS?.agreement ?? "",
                  }}
                ></div>
                <div className="mt-3 row justify-content-center align-items-center">
                <div className="col-12 col-md d-flex justify-content-center justify-content-md-end">
                  <span className="required-icon">必須</span>
                </div>
                <div className="col-12 col-md d-flex justify-content-center justify-content-md-start">
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="personalInformation"
                        checked={isAgreements}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            isAgreements: e.target.checked,
                          }))
                        }
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: "16px",
                          },
                        }}
                        size="small"
                      />
                    }
                    label="同意する"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                      },
                    }}
                  />
                </div>
              </div>
                </>
                )}

          <div className="register-form_sections">
            <BasicInfo
              id="BasicInfo"
              isShow={true}
              isShowPosition={true}
              errorMess={errorMess}
              onChangeValidate={(value) => {
                setState((prevState) => ({
                  ...prevState,
                  currentBasicValid: value ?? 0,
                }));
              }}
              onGetErr={(value) => {
                setState((prevState) => ({
                  ...prevState,
                  errorFormBasic: value,
                }));
              }}
              formData={userMetaDataDetail ?? {}}
              onChangeData={(value) => {
                if (value.profile?.contactType) {
                  setState((prevData) => ({
                    ...prevData,
                    userMetaData: {
                      ...prevData.userMetaData,
                      profile: {
                        ...prevData.userMetaData?.profile,
                        fullName: value.profile?.fullName,
                        fullNameKana: value.profile?.fullNameKana,
                        birth: value.profile?.birth,
                        genderCode: value.profile?.genderCode,
                        occupationCode: value.profile?.occupationCode,
                        contactType: value?.profile?.contactType,
                      },
                      workPlaceInfo: {
                        ...prevData.userMetaData?.workPlaceInfo,
                        positionCode: value.workPlaceInfo?.positionCode,
                        affiliationCodes: value.workPlaceInfo?.affiliationCodes,
                      },
                    },
                  }));
                }
              }}
            />
            <BasicInterests
              id="BasicInterests"
              errorMess={errorMess}
              userData={userMetaDataDetail ?? {}}
              onChangeData={(value: any) => {
                setState((prevData) => ({
                  ...prevData,
                  userMetaData: {
                    ...prevData.userMetaData,
                    interest: {
                      ...prevData.userMetaData?.interest,
                      industoryCodes: value.interest?.industoryCodes,
                      jobCodes: value.interest?.jobCodes,
                      jobChangeCode: value.interest?.jobChangeCode,
                      environmentBusinessCodes:
                        value.interest?.environmentBusinessCodes,
                    },
                  },
                }));
              }}
              onChangeValidate={(value: any) => {
                setState((prevState) => ({
                  ...prevState,
                  currentInterestValid: value ?? 0,
                }));
              }}
            />
            <WorkPlace
              id="WorkPlace"
              errorMess={errorMess}
              onGetErr={(value) => {
                setState((prevState: any) => ({
                  ...prevState,
                  errorFormContact: value,
                }));
              }}
              onChangeSubData={(value: any) => {
                setState((prevState) => ({
                  ...prevState,
                  subContactValue: {
                    ...prevState.subContactValue,
                    zip01: value.zip01,
                    zip02: value.zip02,
                    phone01: value.phone01,
                    phone03: value.phone03,
                    phone02: value.phone02,
                    mobile01: value.mobile01,
                    mobile02: value.mobile02,
                    mobile03: value.mobile03,
                    fax1: value.fax1,
                    fax2: value.fax2,
                    fax3: value.fax3,
                  },
                }));
              }}
              formData={userMetaDataDetail ?? {}}
              onChangeValidate={(value) => {
                setState((prevState) => ({
                  ...prevState,
                  currentWorkPlaceValid: value ?? 0,
                }));
              }}
              onChangeData={(value) => {
                setState((prevData) => ({
                  ...prevData,
                  userMetaData: {
                    ...prevData.userMetaData,
                    workPlaceInfo: {
                      ...prevData.userMetaData?.workPlaceInfo,
                      companyName: value.workPlaceInfo?.companyName,
                      postalCode: value.workPlaceInfo?.postalCode,
                      prefectureCode: value.workPlaceInfo?.prefectureCode,
                      city: value.workPlaceInfo?.city,
                      line: value.workPlaceInfo?.line,
                      departmentName: value.workPlaceInfo?.departmentName,
                      sameAsLoginEmailAddress:
                        value.workPlaceInfo?.sameAsLoginEmailAddress,
                      emailAddress: value.workPlaceInfo?.emailAddress,
                      phoneNumber: value.workPlaceInfo?.phoneNumber,
                      mobilePhoneNumber: value.workPlaceInfo?.mobilePhoneNumber,
                      faxNumber: value.workPlaceInfo?.faxNumber,
                      lbcCode: value.workPlaceInfo?.lbcCode,
                    },
                  },
                }));
              }}
              forceWorkPlaceValidate= {true}
            />
            <HomePlace
              id="HomePlace"
              errorMess={errorMess}
              onGetErr={(value) => {
                setState((prevState: any) => ({
                  ...prevState,
                  errorFormHomePlace: value,
                }));
              }}
              onChangeSubData={(value: any) => {
                setState((prevState) => ({
                  ...prevState,
                  subContactValue: {
                    ...prevState.subContactValue,
                    homeZip01: value.homeZip01,
                    homeZip02: value.homeZip02,
                    homePhone01: value.homePhone01,
                    homePhone03: value.homePhone03,
                    homePhone02: value.homePhone02,
                    homeMobile01: value.homeMobile01,
                    homeMobile02: value.homeMobile02,
                    homeMobile03: value.homeMobile03,
                  },
                }));
              }}
              formData={userMetaDataDetail ?? {}}
              onChangeValidate={(value) => {
                setState((prevState) => ({
                  ...prevState,
                  currentHomePlaceValid: value ?? 0,
                }));
              }}
              onChangeData={(value) => {
                setState((prevData) => ({
                  ...prevData,
                  userMetaData: {
                    ...prevData.userMetaData,
                    profile: {
                      ...prevData.userMetaData?.profile,
                      address: value.profile?.address,
                      mobilePhoneNumber: value.profile?.mobilePhoneNumber,
                      phoneNumber: value.profile?.phoneNumber,
                    },
                  },
                }));
              }}
              forceWorkPlaceValidate= {true}
            />

            <div className={`-body-item -item_edit`}>
              <dt className="-middle -notifi">
                <label>
                  <span className="-span">メールマガジン</span>
                </label>
              </dt>
              <dd>
                <div className="form-col -col">
                  <div className="-form-col_item">
                    <h6 className="header-new">
                      {t("features.notification.kaigiHotTopics")}
                    </h6>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="sendenkaigiInfo"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  sendenkaigiInfo: checked,
                                },
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.sendenkaigiInfo ?? true}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.sendenkaigiInfo")}
                      className="-form-label-item"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="classInfo"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  classInfo: checked,
                                },
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.classInfo ?? false}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.classInfo")}
                      className="-form-label-item"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="contestsAwards"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  contestsAwards: checked,
                                }
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.contestsAwards ?? true}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.contestsAwards")}
                      className="-form-label-item"
                    />
                    <h6 className="-header-new">編集部からのBreaking News</h6>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="advertimes"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  advertimes: checked,
                                }
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.advertimes ?? false}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.adverTimesCheckBox")}
                      className="-form-label-item"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="digitalMagazine"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  digitalMagazine: checked,
                                }
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.digitalMagazine ?? false}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.magazineCheckBox")}
                      className="-form-label-item"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="editorialSendenkaigi"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  editorialSendenkaigi: checked,
                                }
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.editorialSendenkaigi ?? false}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.editorialSendenkaigi")}
                      className="-form-label-item"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="editorialHansokukaigi"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  editorialHansokukaigi: checked,
                                }
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.editorialHansokukaigi ?? false}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.editorialHansokukaigi")}
                      className="-form-label-item"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="editorialKohokaigi"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  editorialKohokaigi: checked,
                                }
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.editorialKohokaigi ?? false}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.editorialKohokaigi")}
                      className="-form-label-item"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="editorialBrain"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  editorialBrain: checked,
                                }
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.editorialBrain ?? false}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.editorialBrain")}
                      className="-form-label-item"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="environmentalBusinessOnline"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  environmentalBusinessOnline: checked,
                                }
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.environmentalBusinessOnline ?? false}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.environmentalBusinessOnline")}
                      className="-form-label-item"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="environmentalBusinessOnlineNews"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  environmentalBusinessOnlineNews: checked,
                                }
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.environmentalBusinessOnlineNews ?? false}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.environmentalBusinessOnlineNews")}
                      className="-form-label-item"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="editorialBooks"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  editorialBooks: checked,
                                }
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.editorialBooks ?? false}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.editorialBooks")}
                      className="-form-label-item"
                    />
                    <h6 className="-header-new">Additional Information</h6>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="adPlacementSponsorship"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setState((prevData) => ({
                              ...prevData,
                              userMetaData: {
                                ...prevData.userMetaData,
                                newsletterSubscription: {
                                  ...prevData.userMetaData?.newsletterSubscription,
                                  adPlacementSponsorship: checked,
                                }
                              },
                            }));
                          }}
                          checked={state.userMetaData?.newsletterSubscription?.adPlacementSponsorship ?? false}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                            "&.Mui-checked": {
                              color: "#009999",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t("features.notification.adPlacementSponsorship")}
                      className="-form-label-item"
                    />
                    {/* <ErrorMsg
                                      error={errors.occupationCode}
                                      className="invalid-danger"
                                    /> */}
                  </div>
                </div>
              </dd>
            </div> 
          </div>

          <div className="register-form_submit">
            <Button
              className="register-form_btn js-register-form_btn"
              onClick={handleConfirm}
              disabled={!isAgreeTerms || (dataMicroCMS?.agreement ? !isAgreements : false)}
            >
              入力内容を確認する
            </Button>
          </div>
          {dataMicroCMS?.notice ? (
            <>
              <h4 className="pb-2">申込みの注意事項</h4>
              <div
                className="notice"
                dangerouslySetInnerHTML={{
                  __html: dataMicroCMS?.notice ?? "",
                }}
              ></div>
              { ondemand ? (
                <ul style={{ marginTop: '-15px' }}>
                  <li>視聴はお申込み者限りとしており、複数名での受講の場合、人数分のお申込みが必要です。</li>
                  <li>お申込者には、宣伝会議IDを通じて視聴環境をご提供しております。同一IDでの複数人での視聴・社内上映などは固くお断りしております。</li>
                </ul>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}
        </Box>
      )}
      {display_mode === 2 && (
        <Box className="survey_answer-page mt20">
          <div className="col-md-12">
            <h2>{content.noti}</h2>
            <p>
              {content.mess}
              <br />
              <span style={{ whiteSpace: "pre-line" }}>{content.hint}</span>
              <br />
              <span style={{ whiteSpace: "pre-line" }}>自動で前の画面に戻ります。</span>
            </p>
          </div>

          <div className="register-form_submit">
            <Button
              className="register-form_btn "
              onClick={() => {
                const urlParams = new URLSearchParams(window.location.search);
                const event_id = urlParams.get("event");
                const urlReturn = urlParams.get("urlReturn") ?? "";
                if(urlReturn && urlReturn !== "") {
                  window.location.href = urlReturn;
                } else {
                  window.location.href = event_id
                    ? `${appConfig.SPA_EVENT_WEB}/marketing/event/${event_id}`
                    : `${appConfig.SPA_EVENT_WEB}/marketing/event`;
                }
              }}
            >
              前の画面に戻る
            </Button>
          </div>
        </Box>
      )}
    </>
  );
};

export default SurveyAnswer;
